import { useRef } from 'react'

type ClickHandlers = {
  onClick?: () => void
  onDoubleClick?: () => void
  delay?: number // 延迟时间（区分单击和双击）
}

export function useClick({
  onClick,
  onDoubleClick,
  delay = 250, // 默认 250ms
}: ClickHandlers) {
  const timer = useRef<NodeJS.Timeout | null>(null)

  const handleClick = () => {
    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = null
    }

    timer.current = setTimeout(() => {
      onClick?.()
      timer.current = null
    }, delay)
  }

  const handleDoubleClick = () => {
    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = null
    }
    onDoubleClick?.()
  }

  return {
    onClick: handleClick,
    onDoubleClick: handleDoubleClick,
  }
}
